<template>
	<keep-alive>
		<div style="">
			<el-row>
				<!-- 				<el-col :span="3">
					<div class="flex">
						<div class="blue"></div>
						<div class="title">发型师档案</div>
					</div>
				</el-col> -->
				<el-col :span="1" style="float: right; margin-right: 20px;">
					<el-popover trigger="hover" placement="top-start" title="计算公式" width="500"
						content="业绩完成率% * 80+(会员达标)20分+(会员附加)10分+(业绩附加)10分">
						<el-button slot="reference" @click="onload" size="small">
							<i class="el-icon-refresh"></i> 刷 新
						</el-button>
					</el-popover>
				</el-col>
			</el-row>
			<el-row>
				<el-col class="top" :span="24">
					<el-col class="t" :span="1">搜索</el-col>
					<el-col :span="3">
						<el-select v-model="filter.workerName" size="small" style="width: 120px;margin-right:10px;"
							placeholder="全部">
							<el-option v-for="item in hiarlist" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-col>
					<el-col class="t" :span="1">门店</el-col>
					<el-col :span="4">
						<el-select @change="getFilelist()" v-model="filter.storeId" placeholder="全部门店" clearable
							style="width: 160px;margin-right:10px;" size="small">
							<el-option-group label="营业门店" class="store">
								<el-option v-for="item in storeList" :key="item.id" :label="item.title"
									:value="item.id">
								</el-option>
							</el-option-group>
							<el-option-group label="结业门店">
								<el-option v-for="item in storeEnd" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-option-group>
							</el-option>
						</el-select>
					</el-col>
					<el-col class="t" :span="1">月份</el-col>
					<el-col :span="4">
						<el-date-picker @change="getFilelist()" value-format="yyyy-MM" size="small"
							v-model="filter.month" style="width: 150px;" type="month" placeholder="选择月">
						</el-date-picker>
					</el-col>
					<el-col class="t" :span="1">等级</el-col>
					<el-col :span="4">
						<el-select v-model="level" size="small" @change="getFilelist()"
							style="width: 180px;margin-right:10px;" placeholder="全部">
							<el-option v-for="item in options" :key="item.label" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="3" style="float: right;">
						<el-button type="primary" @click="getFilelist" size="small">筛 选</el-button>
						<el-button type="infor" @click="export01()" size="small">导 出</el-button>
					</el-col>
				</el-col>
			</el-row>
			<div class="hairlist" v-loading="loading">
				<div class="list" @click="godeatil(item)" v-for="item in list" :key="item.index">
					<div class="listtop">
						<div class="headlike">
							<img :src="item.avatar" />
						</div>
						<div class="message">
							<div class="name">{{item.workerName}}</div>
							<div class="type">{{item.levelTitle}}</div>
							<div class="store">{{item.storeName}}</div>
						</div>
						<div class="garde">
							<div>
								{{item.level}}
							</div>
							<div>{{item.score}}分</div>
						</div>
					</div>
					<div class="listbottom">
						<div class="listbottom_s1">
							<div>差评</div>
							<div class="numText">{{item.badCount}}</div>
						</div>
						<div class="border"></div>
						<div class="listbottom_s0">
							<div>会员销售</div>
							<div class="numText">{{item.memberNum}}</div>
						</div>
						<div class="border"></div>
						<div class="listbottom_s">
							<div>业绩达标率</div>
							<div class="numText">{{item.turnoverRate}}%</div>
						</div>
						<div class="border"></div>
						<div class="listbottom_s2">
							<div>平均服务时长</div>
							<div class="numText">{{item.avgServiceTime2}}min</div>
						</div>
					</div>
				</div>
			</div>
			<div class="pagewai" style="text-align: center;">
				<div class="paging">
					<el-pagination @current-change="handlePageChange" @size-change="handleSizeChange" background
						layout="sizes,prev, pager, next" :page-count="pageNo" :page-sizes="[10, 20, 30, 50, 100]"
						:page-size="pageSize" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</keep-alive>
</template>

<script>
	import {
		url
	} from '../../utils/index.js'
	export default {
		data() {
			return {
				hiarlist: [],
				url: url(),
				list: [],
				filter: {
					month: '',
					workerName: "",
					storeId: ""
				},
				//第三部分表格
				fileTableData: [],
				serviceList: [],
				storeEnd: [],
				storeList: [],
				pageNo: 1,
				pageSize: 50,
				level: '',
				loading: false,
				options: [{
					value: "",
					label: "全部"
				}, {
					value: "S",
					label: "S"
				}, {
					value: "A",
					label: "A"
				}, {
					value: "B",
					label: "B"
				}, {
					value: "C",
					label: "C"
				}, {
					value: "D",
					label: "D"
				}],
			}
		},
		mounted() {
			const date1 = new Date()
			const nowDay =
				`${date1.getFullYear()}-${date1.getMonth() + 1 < 10 ? `0${date1.getMonth() + 1}` : date1.getMonth() + 1}`
			this.filter.month = nowDay
			this.getstorelist()
			this.getFilelist()
		},
		methods: {
			// 获取门店列表
			getstorelist() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType == 1) {
							this.storeEnd.push(ele) //结业门店
						} else {
							this.storeList.push(ele) //营业门店
						}
					})
				})
			},
			onload() {
				location.reload()
			},
			getFilelist() {
				// document.cookie = "storeId=" + escape(JSON.stringify(this.filter.storeId));
				this.loading = true
				var a = "?month=" + this.filter.month +
					"&workerId=" + this.filter.workerName +
					"&storeId=" + this.filter.storeId +
					"&pageNum=" + this.pageNo +
					"&pageSize=" + this.pageSize +
					"&level=" + this.level + "&content=scoreDesc"
				this.$http.get("dWorkerFile/list" + a).then(res => {
					var list = res.body.data.filter(e => e.test != 1)
					for (let i in list) {
						list[i].avgServiceTime2 = list[i].avgServiceTime.split(":")[1]
					}
					this.list = list
					this.total = res.body.total
					this.loading = false
				})
			},
			godeatil(e) {
				// 保存数据
				localStorage.setItem('hairuser', JSON.stringify(e))
				this.$router.push({
					path: '/hairfilesdetail',
					query: {
						id: e.workerId
					}
				})
			},
			export01() {
				var a = "?month=" + this.filter.month +
					"&workerId=" + this.filter.workerName +
					"&storeId=" + this.filter.storeId +
					"&pageNum=" + this.pageNo +
					"&pageSize=" + this.pageSize +
					"&level=" + this.level
				window.location.assign(this.url + "dWorkerFile/export" + a)
			},
			handlePageChange(val) {
				this.pageNo = val
				this.getFilelist()
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.getFilelist()
			}
		}
	}
</script>

<style lang="less" scoped>
	.flex {
		display: flex;
	}

	.t {
		margin-top: 3px;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;
	}

	.blue {
		width: 5px;
		height: 15px;
		background: #409EFF;
		border-radius: 2px;
		margin-right: 8px;
		position: relative;
		top: 4px;
	}

	.top {
		width: 100%;
		height: 67px;
		background: #FFFFFF;
		box-shadow: 2px 2px 4px 2px rgba(147, 147, 147, 0.5);
		border-radius: 5px;
		box-sizing: border-box;
		margin: 20px 0 0 0;
		padding: 20px 10px 10px 10px;
	}

	// 发型师列表
	.hairlist {
		// padding-right: 10px;
		margin-left: -5px;
		min-height: 100px;
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		margin-top: 20px;

		.list {
			width: 24.5%;
			margin-left: 5px;
			// margin-right: 1.2%;
			margin-bottom: 18px;
			height: 140px;
			background: #FFFFFF;
			// box-shadow: 0px 5px 5px 5px rgba(187, 186, 186, 0.5);
			box-shadow: 1px 5px 5px 2px #e8e8e8;
			border-radius: 8px;
			border: 1px solid #dcdcdc;
			box-sizing: border-box;
			padding: 5px;

			.listtop {
				display: flex;

				.headlike {
					width: 75px;
					height: 75px;
					margin-left: 1%;
					border-radius: 50%;
					overflow: hidden;

					>img {
						width: 100%;
						height: 100%;
					}
				}

				.message {
					padding-left: 8%;
					flex: 1;

					>div:nth-child(1) {
						font-size: 18px;
						font-family: SourceHanSansCN-Bold, SourceHanSansCN;
						font-weight: bold;
						color: #2D2D2D;
					}

					>div:nth-child(2) {
						width: 75px;
						height: 18px;
						background: #00B648;
						border-radius: 2px;
						border: 0px solid #979797;
						font-size: 14px;
						font-family: SourceHanSansCN;
						color: #FFFFFF;
						line-height: 9px;
						text-align: center;
						line-height: 15px;
						margin-top: 5px;
						padding-top: 3px;
					}

					>div:nth-child(3) {
						width: 120px;
						font-size: 12px;
						font-family: SourceHanSansCN;
						color: #333333;
						margin-top: 5px;
					}
				}

				.garde {
					width: 80px;
					text-align: center;

					>div:nth-child(1) {
						font-size: 28px;
						font-family: SourceHanSansCN-Bold, SourceHanSansCN;
						font-weight: bold;
						color: #FF0000;
						line-height: 36px;
					}
				}
			}

			// 
			.listbottom {
				display: flex;
				width: 100%;
				margin-top: 10px;
				margin-left: -5px;

				>.listbottom_s1 {
					width: 18%;
					font-size: 14px;
					text-align: center;
				}

				>.listbottom_s0 {
					width: 23%;
					font-size: 14px;
					text-align: center;
					//       flex: 1;
					// >div:nth-child(1){
					// 	display: realtive;
					// 	width: 80px;
					// 	margin-left:-8px;
					// 	// transform: scale(0.7);
					// }
				}

				>.listbottom_s2 {
					width: 33%;
					font-size: 14px;
					text-align: center;
				}

				>.listbottom_s {
					width: 27%;
					font-size: 14px;
					text-align: center;
				}

				.border {
					width: 1px;
					height: 35px;
					font-size: 8px;
					background: #ababab;
					margin: 2px 1px;

				}
			}

			// 
		}

		// >.list:nth-child(5n){
		// 	margin-right: 0;
		// }
	}
</style>